import { createSlice } from '@reduxjs/toolkit';

import { registrationComplete } from '../registration-complete/registration-complete-reducer';
import { Steps, StepTypes } from './manage-steps-types';

export interface State {
  activeStep: StepTypes;
}

interface setActiveStepAction {
  type: string;
  payload: StepTypes;
}

export const initialState: State = {
  activeStep: Steps.LOADING,
};

const manageStepSlice = createSlice({
  name: 'steps',
  initialState,
  reducers: {
    setActiveStep(state: State, action: setActiveStepAction) {
      state.activeStep = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(registrationComplete.type, state => {
      state.activeStep = Steps.REGISTRATION_COMPLETE;
    });
  },
});

export const { setActiveStep } = manageStepSlice.actions;

// eslint-disable-next-line import/no-default-export
export default manageStepSlice.reducer;
